import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { OpsightLogo } from './OpsightLogo';
import { getLoginUrl, scrollToSection } from '../utils/config';
import './Header.css';

export const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (sectionId: string) => {
    setIsMobileMenuOpen(false);
    
    // Se não estiver na página Home, redirecionar para Home com hash
    if (location.pathname !== '/') {
      navigate(`/#${sectionId}`);
    } else {
      // Se já estiver na Home, fazer scroll normalmente
      scrollToSection(sectionId);
    }
  };

  const handleLogin = () => {
    window.location.href = getLoginUrl();
  };

  const handleContratar = () => {
    window.location.href = getLoginUrl();
  };

  return (
    <header className={`landing-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="header-logo">
          <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>
            <OpsightLogo size={140} variant="dark" />
          </Link>
        </div>

        <nav className={`header-nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <a href="#features" onClick={(e) => { e.preventDefault(); handleNavClick('features'); }}>
            Features
          </a>
          <a href="#pricing" onClick={(e) => { e.preventDefault(); handleNavClick('pricing'); }}>
            Preços
          </a>
          <a href="#about" onClick={(e) => { e.preventDefault(); handleNavClick('about'); }}>
            Sobre
          </a>
          <Link to="/release-notes" onClick={() => setIsMobileMenuOpen(false)}>
            Release Notes
          </Link>
        </nav>

        <div className={`header-actions ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <button className="btn-login" onClick={handleLogin}>
            Login
          </button>
          <button className="btn-primary" onClick={handleContratar}>
            Contratar
          </button>
        </div>

        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

